<template>
    <div class="skill-bar-wrap">
        <div class="skill-bar-track">
            <div
                class="skill-bar-fill"
                :class="{ 'fill-red': 'skill-bar-fill--red', 'fill-neutral': 'skill-bar-fill--neutral' }[type] || 'skill-bar-fill--blue'"
                :style="{ width: pct + '%' }"
            ></div>
        </div>
        <span class="skill-bar-pct">{{ pct }}%</span>
    </div>
</template>

<script>
import { defineComponent, computed } from 'vue';

export default defineComponent({
    props: {
        importanceItem: { type: Number, default: 0 },
        type: { type: String, default: 'fill' }
    },
    setup(props) {
        const pct = computed(() => Math.min(100, Math.round((props.importanceItem || 0) * 100)));
        return { pct };
    }
});
</script>

<style scoped>
.skill-bar-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
}
.skill-bar-track {
    flex: 1;
    height: 6px;
    background: var(--tm-border-soft, rgba(125, 161, 191, 0.15));
    border-radius: 999px;
    overflow: hidden;
    min-width: 60px;
}
.skill-bar-fill {
    height: 100%;
    border-radius: 999px;
    transition: width 0.4s ease;
}
/* "blue"/"red" are the prop's historical names; the actual colors are the
   app-wide have/gap pair so this reads the same as every other coverage
   indicator (chips, meters, rings). */
.skill-bar-fill--blue {
    background: var(--tm-have, var(--blue));
}
/* No comparison (public occupation pages): plain importance, no have/gap meaning. */
.skill-bar-fill--neutral {
    background: var(--tm-accent);
}
.skill-bar-fill--red {
    background: var(--tm-gap, #d9694a);
}
.skill-bar-pct {
    font-size: 11px;
    font-family: var(--tm-font-mono, inherit);
    color: var(--tm-ink-muted, rgba(47, 74, 96, 0.55));
    white-space: nowrap;
    min-width: 30px;
    text-align: right;
}
</style>